import { PrimaryButton } from '@banhala/ui-kit';

interface WishlistCartButtonProps {
  onPress: () => void;
}

/**
 * 찜탭 상품카드 하단 "장바구니 담기" 라인 버튼 (EXP1768 B/C군 공통 노출).
 * iOS WishlistCartProductCell / Android FolderGoodsSection CartButton 대응.
 */
export const WishlistCartButton = ({ onPress }: WishlistCartButtonProps) => {
  return (
    <PrimaryButton
      variant={'fill'}
      color={'blue'}
      size={'xsmall'}
      outline
      onPress={onPress}
      testID={'찜상품카드장바구니담기버튼'}
    >
      장바구니 담기
    </PrimaryButton>
  );
};
